import React from 'react';
import { connect } from 'react-redux';

import ExportUsers from './ExportUsers';
import ExportAccounts from './ExportAccounts';
import { getFreeSystems } from '../../../stores/actions/installerActions';
import { getSystemsNodesShort } from '../../../stores/actions/logsActions';
import ExportSystems from './ExportSystems';
import ExportMeasurements from './ExportMeasurements';
import ExportGnuplotCharts from './ExportGnuplotCharts';
import ExportReport from './ExportReport';
import ExportDevices from './ExportDevices';
import ExportLogs from './ExportLogs';
import ExportInstallationProtocol from './ExportInstallationProtocol';
import _ from 'lodash';

import { Grid } from '@material-ui/core';


interface IExportProps {
    mobileView: boolean;
    systemsNodesShort: any[];
    getFreeSystems: () => void;
    getSystemsNodesShort: () => void;
}

class Export extends React.Component<IExportProps> {

    componentWillMount(): void {
        this.props.getFreeSystems();
        this.props.getSystemsNodesShort();
    }

    render() {
        const { mobileView, systems, systemsNodesShort } = this.props;
        const sortedSystems = [...systems].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
        const w2Systems = _.filter(sortedSystems, { systemVersion: 'W2' });
        const w4Systems = _.filter(sortedSystems, (s) => s.systemVersion?.startsWith('W4'));
        const measuringNodes = _.filter([...systemsNodesShort], function (sns) { return ['laser', 'inclinometer', 'both'].includes(sns.mainSensorType)});

        return (<>
                <Grid container spacing={2}>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportUsers
                            systems={w2Systems}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportAccounts
                            systems={sortedSystems}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportSystems
                            systems={sortedSystems}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportDevices 
                            systems={sortedSystems}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportMeasurements
                            systems={sortedSystems}
                            systemsNodesShort={measuringNodes}
                        />
                    </Grid>
               
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportReport
                            systems={sortedSystems}
                            systemsNodesShort={measuringNodes}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportReport
                            variant='signalQuality'
                            systems={w4Systems}
                            systemsNodesShort={measuringNodes}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportGnuplotCharts
                            systems={sortedSystems}
                            systemsNodesShort={measuringNodes}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportLogs
                            systems={sortedSystems}
                            systemsNodesShort={measuringNodes}
                        />
                    </Grid>
                    <Grid item xs={mobileView ? 12 : 6}>
                        <ExportInstallationProtocol
                            systems={sortedSystems}
                        />
                    </Grid>
                </Grid>
                </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        mobileView: state.dashboard.mobileView,
        systems: state.dashboard.FreeSystems,
        systemsNodesShort: state.dashboard.systemsNodesShort
    };
};
const actions = { getFreeSystems, getSystemsNodesShort };

export default connect(mapStateToProps, actions)(Export);
